import React, { useState, useEffect } from 'react';
import ProjectModal from './ProjectModal';
import projects from '../data/projects';
import '../styles/ProjectGallery.css';

const ProjectGallery = () => {
  const mobiileScreenSize = 768;

  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= mobiileScreenSize);

  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const detectTouchDevice = () => {
      setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
    };

    detectTouchDevice();

    window.addEventListener('resize', detectTouchDevice);

    return () => {
      window.removeEventListener('resize', detectTouchDevice);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= mobiileScreenSize);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const openModal = (project) => {
    console.log('openModal called for:', project);
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  return (
    <div className="grid-container">
      {projects.map((project, index) => (
        <div
          key={index}
          className="project-card"
          onClick={() => openModal(project)}
        >
          <div className="image-wrapper">
            <img
              src={project.banner}
              alt={project.title}
              className="project-image"
            />
            {!isTouchDevice && (<div className="overlay">
              <h3>{project.title.toUpperCase()}</h3>
              <div className='role'>
                <p>-view-</p>
              </div>
            </div>)}
          </div>
        </div>
      ))}
      <ProjectModal isOpen={isModalOpen} onClose={closeModal} project={selectedProject} />
    </div>
  );
};

export default ProjectGallery;
